// frontend/src/components/Auth/ForbiddenPage.jsx
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiShield, FiArrowLeft, FiHome } from 'react-icons/fi';

const ForbiddenPage = () => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { from, menuKey, operation } = location.state || {};

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', minHeight: '60vh', padding: 32, textAlign: 'center',
    }}>
      <div style={{
        width: 80, height: 80, borderRadius: '50%',
        background: '#fee2e2', display: 'flex', alignItems: 'center',
        justifyContent: 'center', marginBottom: 24,
      }}>
        <FiShield size={36} color="#dc2626"/>
      </div>

      <h2 style={{ fontSize: 24, fontWeight: 700, color: 'var(--gray-900)', marginBottom: 8 }}>
        Acesso Negado
      </h2>

      <p style={{ fontSize: 15, color: 'var(--gray-500)', marginBottom: 6, maxWidth: 400 }}>
        Não tem permissão para aceder a esta página.
      </p>

      {menuKey && (
        <p style={{ fontSize: 12, color: 'var(--gray-400)', marginBottom: 24 }}>
          Módulo: <strong>{menuKey}</strong>
          {operation && <> · Operação: <strong>{operation}</strong></>}
        </p>
      )}

      <p style={{ fontSize: 13, color: 'var(--gray-400)', marginBottom: 28, maxWidth: 360 }}>
        Contacte o administrador do sistema se precisar de acesso a esta funcionalidade.
      </p>

      <div style={{ display: 'flex', gap: 12 }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            display: 'flex', alignItems: 'center', gap: 6,
            padding: '8px 16px', borderRadius: 6, border: '1px solid var(--gray-200)',
            background: 'white', cursor: 'pointer', fontSize: 14, color: 'var(--gray-700)',
          }}>
          <FiArrowLeft size={14}/> Voltar
        </button>
        <button
          onClick={() => navigate('/')}
          style={{
            display: 'flex', alignItems: 'center', gap: 6,
            padding: '8px 16px', borderRadius: 6, border: 'none',
            background: 'var(--primary)', cursor: 'pointer',
            fontSize: 14, color: 'white', fontWeight: 600,
          }}>
          <FiHome size={14}/> Início
        </button>
      </div>
    </div>
  );
};

export default ForbiddenPage;